import Vue from 'vue'
import Vuex from 'vuex'
// import { firestore } from '../firebase'
import localforage from 'localforage'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    version: 1.414,
    user: null,
    apiUrl: 'https://us-central1-jacksons-earth-moving.cloudfunctions.net/api',
    localApiUrl: 'http://localhost:5000/jacksons-earth-moving/us-central1/api',
    googleApiKey: 'AIzaSyC3tus4DtK2kXYOoeH7Ha8HT_9RIcTHD5Q',
    emailDomain: 'sdfdev.com',
    isPhone: false,
    decimalHours: true,
    lastRouterPath: '',
    settings: {
      decimalHours: {
        type: 'boolean',
        value: true
      },
      alerts: [
        'smsUrgentRepairs'
      ]
    },
    defaultStartTime: '7:00 am',
    defaultEndTime: '3:30 pm',
    workingSecondsPerDay: 8 * 60 * 60,
    pages: [
      { name: 'Home', icon: 'home', to: '/home' },
      { name: 'My Hours', icon: ['far', 'clock'], to: '/my-hours', privilege: 'time keeping' },
      { name: 'Sat Roster', icon: ['far', 'calendar-check'], to: '/saturday-roster', privilege: 'saturday roster, saturday roster admin' },
      { name: 'My Profile', icon: 'user-circle', to: '/my-profile', privilege: 'my profile' },
      { name: 'Pre Start', icon: 'check', to: '/pre-start', privilege: 'pre start' },
      { name: 'Machines', icon: 'truck', to: '/machines', privilege: 'machines' },
      { name: 'Check Lists', icon: 'check', to: '/check-lists', privilege: 'check lists' },
      { name: 'Leave', icon: 'beer', to: '/leave', privilege: 'leave, leave admin' },
      { name: 'Machine Hire', icon: 'truck-loading', to: '/machine-hire', privilege: 'machine hire' },
      { name: 'Incidents', icon: 'exclamation-triangle', to: '/incidents', privilege: 'incidents' },
      { name: 'Employees', icon: 'address-card', to: '/employee-register', privilege: 'employee register' },
      { name: 'Admin', icon: 'cog', to: '/admin', privilege: 'admin' },
      { name: 'Hours', icon: 'calendar-alt', to: '/admin/hours', privilege: 'admin', isChild: true },
      { name: 'Users', icon: 'users', to: '/admin/users', privilege: 'admin', isChild: true },
      { name: 'Incidents Reports', icon: 'exclamation-circle', to: '/admin/incidents', privilege: 'admin', isChild: true },
      { name: 'Test', icon: 'users', to: '/test', privilege: 'test', isChild: true }
    ],
    printer: false,
    showImageUrl: null
  },
  getters: {
    // BASIC getters
    version (state) { return state.version },
    apiUrl (state) { return document.location.hostname === 'localhost' ? state.localApiUrl : state.apiUrl },
    isPhone (state) { return state.isPhone },
    decimalHours (state) { return state.decimalHours },
    user (state) { return state.user },
    emailDomain (state) { return state.emailDomain },
    localApiUrl (state) { return state.localApiUrl },
    lastRouterPath (state) { return state.lastRouterPath },
    settings (state) { return state.settings },
    pages (state) { return state.pages },
    defaultStartTime (state) { return state.defaultStartTime },
    defaultEndTime (state) { return state.defaultEndTime },
    workingSecondsPerDay (state) { return state.workingSecondsPerDay },
    printer  (state) { return state.printer },
    googleApiKey (state) { return state.googleApiKey },
    showImageUrl (state) { return state.showImageUrl },

    // getters
    isAdmin (state) {
      if (state.user && state.user.privileges) {
        return state.user.privileges.includes('admin')
      }
      return false
    }
  },
  mutations: {
    // BASIC mutations
    SET_ISPHONE (state, payload) { state.isPhone = payload },
    SET_DECIMAL_HOURS  (state, payload) { state.decimalHours = payload },
    SET_PRINTER (state, payload) { state.printer = payload },
    SET_SHOW_IMAGE_URL (state, payload) { state.showImageUrl = payload },

    // mutations
    SET_SETTINGS (state, payload) {
      state.settings = payload
      localforage.setItem('settings', payload)
    },
    SET_USER (state, payload) {
      // console.log('SET_USER', payload)
      state.user = payload
      // localforage.setItem('user', payload)
    },
    SET_LAST_ROUTER_PATH  (state, payload) {
      state.lastRouterPath = payload
      localforage.setItem('routerPath', payload)
    }
  },
  actions: {
    // BASIC actions
    setIsPhone (context, payload) { context.commit('SET_ISPHONE', payload) },
    setDecimalHouts (context, payload) { context.commit('SET_DECIMAL_HOURS', payload) },
    setLastRouterPath (context, payload) { context.commit('SET_LAST_ROUTER_PATH', payload) },
    setSettings (context, payload) { context.commit('SET_SETTINGS', payload) },
    setPrinter (context, payload) { context.commit('SET_PRINTER', payload) },
    setShowImageUrl (context, payload) { context.commit('SET_SHOW_IMAGE_URL', payload) },

    init (context) {
      localforage.config({
        name: 'Jacksons Earthmoving',
        storeName: 'jacksons-earthmoving'
      })

      return new Promise(resolve => {
        localforage.getItem('routerPath').then(routerPath => {
          context.commit('SET_LAST_ROUTER_PATH', routerPath || '')
          localforage.getItem('settings').then(settings => {
            if (settings) {
              context.commit('SET_SETTINGS', settings)
            }
            resolve()
          })
        })
      })
    },

    // actions
    setUser (context, payload) {
      context.commit('SET_USER', payload)
    }
  }
})
